import { PageSlug, HelpPageSchema } from "../types"
import { generateQuestionId } from "./generateQuestionId"

export const extractHelpQuestions = (
  tabName: string,
  mapPageSlugToHelpTab: (pageSlug: PageSlug) => any,
  result?: HelpPageSchema
) => {
  if (!result) return []

  const tab = mapPageSlugToHelpTab(result.slug)
  if (!tab) return []

  return result.fields.sections.flatMap((section) => {
    const subtitle = section.fields.expand_section_title
    return section.fields.expand_item.map((item) => {
      const parsedQuestionAnswer =
        new DOMParser().parseFromString(item.expand_item_content, "text/html").documentElement.textContent ?? ""
      const questionId = generateQuestionId(result.slug, item.expand_item_title)

      return {
        tab,
        tabName,
        questionId,
        title: item.expand_item_title,
        category: [tabName, subtitle].join(" > "),
        answer: parsedQuestionAnswer,
      }
    })
  })
}
